import errorIcon from 'assets/img/error.svg';
import dictionary from 'config/dictionary';
import PropTypes from 'prop-types';
import React from 'react';
import BackButton from '../../BackButton/BackButton';
import styles from '../bankPaymentRedemption.module.scss';

export const AttemptsExhaustedView = ({ senderName }) => (
  <div
    className={styles.container}
    data-test-id="bank-payment-attempts-exhausted-view"
  >
    <img
      className={styles.errorIcon}
      src={errorIcon}
      alt=""
      aria-hidden="true"
    />
    <p className={styles.body}>
      {dictionary.bankPayment.copy.exhaustedBody.replace(
        '[sender]',
        (senderName || '').trim() || 'the sender',
      )}
    </p>
    <BackButton className={styles.backButton} />
  </div>
);

AttemptsExhaustedView.propTypes = {
  senderName: PropTypes.string,
};

export default AttemptsExhaustedView;
